import { initialState } from "./../initialState";
import * as FollowUpsActions from "./followUpsActions";

export const followUpsReducer = (state = initialState.followUps, action) => {
    switch (action.type) {
        case FollowUpsActions.REQUEST_FOLLOW_UP_REASONS:
            return Object.assign({}, state);

        case FollowUpsActions.FOLLOW_UP_DUE_DATE_SUCCEEDED:
            return Object.assign({}, state, {
                dueDate: action.dueDate,
            });
        case FollowUpsActions.REQUEST_FOLLOW_UP_DUE_DATE:
            return Object.assign({}, state);

        case FollowUpsActions.REQUEST_FOLLOW_UP_REASONS_SUCCEEDED:
            return Object.assign({}, state, {
                followUpReasons: action.followUpReasons,
            });

        case FollowUpsActions.REQUEST_FOLLOW_UP_REASONS_FAILED:
            return initialState.followUps.followUpReasons;

        case FollowUpsActions.SAVE_FOLLOW_UPS_INFO:
            return Object.assign({}, state, {
                followUpsRequest: action.followUpsRequest,
            });

        case FollowUpsActions.SAVE_FOLLOW_UPS_INFO_SUCCEEDED:
            return Object.assign({}, state, {
                followUpsResponse: action.followUpsResponse,
            });
        case FollowUpsActions.SAVE_FOLLOW_UPS_INFO_FAILED:
            return initialState.followUps.followUpsResponse;
        case FollowUpsActions.DUPLICATE_CHECK_POPUP:
            return Object.assign({}, state, {
                isOpen: action.payload,
            });
        case FollowUpsActions.NO_DUPLICATES_CHECK:
            return Object.assign({}, state, {
                noDuplicates: action.payload,
            });
        case FollowUpsActions.DUPLICATE_WORKORDERS:
            return {
                ...state,
                duplicateWO: [...state.duplicateWO, ...action.payload],
            };
        case FollowUpsActions.CLEAR_DUPLICATE_WORKORDERS:
            return {
                ...state,
                duplicateWO: initialState.followUps.duplicateWO,
            };
        case FollowUpsActions.SET_DUPLICATE_WORKORDERS:
            return {
                ...state,
                duplicateWO: action.payload,
            };
        case FollowUpsActions.UPDATE_FOLLOW_UPS_INFO_SUCCEEDED:
            return Object.assign({}, state, {
                followUpsResponse: action.followUpsResponse,
            });
        case FollowUpsActions.RESET_FOLLOW_UPS_STATE:
            return { ...initialState.followUps, followUpReasons: state.followUpReasons };
        default:
            return state;
    }
};
